<template>
  <div class="page">
    <div class="head">
        入库审批
    </div>
    <div class="content">
        <div class="bar">
            <el-input style="width:10%" clearable v-model="query.keyword" placeholder="请输入关键字">
                
            </el-input>
            <el-button  class="bartip"  @click="toSearch" size="small" type="primary" round>搜索</el-button>
        </div>
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column
                    prop="name"
                    label="标题">
                </el-table-column>
                <el-table-column
                    prop="question"
                    label="内容描述">
                </el-table-column>
                <el-table-column
                show-overflow-tooltip
                    prop="answer"
                    label="解答">
                </el-table-column>
                <el-table-column
                    prop="createdAt"
                    label="提问时间">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态">
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="approval(record.row)" type="primary">审批</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />
        <!-- 表单 添加入库 -->
        <el-dialog :title="title" :visible.sync="visible" @close="dialogCloseHandler">
            <el-form ref="userForm" :model="form" :rules="rules">
                <el-form-item label="标题" label-width="100px" prop="name">
                <el-input v-model="form.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="内容描述" label-width="100px" prop="question">
                <el-input v-model="form.question" autocomplete="off" />
                </el-form-item>
                <el-form-item label="解答" label-width="100px" prop="answer">
                <el-input v-model="form.answer" autocomplete="off" />
                </el-form-item>
                <el-form-item label="问题类别" label-width="100px" prop="categoryName">
                <el-input v-model="form.categoryName" autocomplete="off" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 表单 修改入库 -->
        <el-dialog :title="title2" :visible.sync="visible2" @close="dialogCloseHandler2">

            <el-radio v-model="audit.status" label="AGREE">通过</el-radio>
            <el-radio v-model="audit.status" label="DENY">不通过</el-radio>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal2">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler2">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],
        query: {
            currentPage: 1,
            size: 10,
            page:0,
            total: 0,
            keyword:'',
            status:'WAIT'
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加入库信息',
        title2:'修改入库信息',
        form: {},
        form2:{},
        rules: {
            
        },
        audit:{
            id:'',
            status:''
        }

    }
 },
 methods:{
     findUserlist(){
        ajaxObj({url: "question-lib",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            console.log(this.tableData);
            this.query.total = response.data.meta.total;
        })
     },
       // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;
    },
    //  搜索
     toSearch(){
        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;
        ajaxObj({url: "question-lib",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
     },


    
    // 添加入库  表单
    dialogCloseHandler() {
        this.$refs.userForm.clearValidate()
    },
    
    toAddHandler() {
      this.form = {}
      this.setTitle('添加入库信息')
      this.showModal()
    },
    setTitle(title) {
      this.title = title
    },
    closeModal() {
      this.visible = false
    },
    showModal() {
      this.visible = true
    },
    submitHandler(){
            // 表单验证
        // this.$refs.userForm.validate((valid) => {
        //     if (valid) {
        //     // 2 提交表单
        //         ajaxObj({url: "users/add-teacher",method: "post",
        //             data:this.form
        //         })
        //         .then((response) => {
        //             this.$message({ type: 'success', message: '添加成功' });
        //             this.reload()                                               
        //         })
        //     } else {
        //         this.$message({ type: 'error', message: '添加失败' })
        //     }
        // })
    },
    // 修改入库  表单
    dialogCloseHandler2() {
        this.$refs.userForm2.clearValidate()
    },
    setTitle2(title2) {
        this.title2 = title2
    },
    closeModal2() {
      this.visible2 = false
    },
    showModal2() {
      this.visible2 = true
    },
    submitHandler2(){
            // 表单验证
            // 2 提交表单
                ajaxObj({url: "question-lib/audit",method: "post",
                    data:this.audit
                })
                .then((response) => {
                    this.$message({ type: 'success', message: '审批完成' });
                    this.reload()                                               
                })
            
    },
    //  删除入库
     deleteHandler(id){
        // if(id){
        //     ajaxObj({url: "users/delete",method: "post", data:{"id":id}})
        //     .then(response => {
        //         this.$message({ type: 'success', message: '删除成功'});
        //         this.reload()
        //     });
        // } else {
        //         this.$message({ type: 'error', message: '删除失败' })
        // }
        
     },
    //  修改入库
    approval(row){
      this.audit.id = row.id;
      this.audit.status = 'AGREE'
      this.setTitle2('审批')
      this.showModal2()
    // ajaxObj({url: "question-lib/audit",method: "post",
    //         data:this.form2
    //     })
    //     .then((response) => {
    //         this.$message({ type: 'success', message: '修改成功' });
    //         this.reload()                                               
    //     })
      
     },
     
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
    console.log(this.currentPage) // 点击第几页
        ajaxObj({url: "question-lib",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findUserlist();
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto;
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/problem/questionApproval.vue